import { useRef, useState } from "react";
import StandardHoverBox from "./StandardHoverBox";
import { useEdgeAwarePosition } from "../../../hooks/useEdgeAwarePosition";

const HoverBoxAnchor = ({
  tooltipText,
  children,
  tooltip = false,
  hide,
}: {
  tooltipText: string;
  children: React.ReactNode;
  tooltip?: boolean;
  hide?: boolean;
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const anchorRef = useRef<HTMLDivElement>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);

  const { showAbove, showToLeft, borderRadius, isReady } = useEdgeAwarePosition(
    anchorRef,
    tooltipRef,
    isVisible,
    tooltip,
  );

  const tooltipStyle = {
    opacity: isReady ? 1 : 0,
    borderRadius,
    ...(showAbove
      ? { top: "auto", bottom: "100%" }
      : { top: "100%", bottom: "auto" }),
    ...(showToLeft ? { left: "auto", right: 0 } : { left: 0, right: "auto" }),
  };

  return (
    <div
      ref={anchorRef}
      className="relative inline-block"
      tabIndex={0}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
      onFocus={() => setIsVisible(true)}
      onBlur={() => setIsVisible(false)}
      onKeyDown={(e) => { if (e.key === "Escape") setIsVisible(false); }}
    >
      {children}
      {isVisible && !hide && (
        <StandardHoverBox ref={tooltipRef} text={tooltipText} style={tooltipStyle} />
      )}
    </div>
  );
};

export default HoverBoxAnchor;
